import React from "react";
import { Link } from "gatsby";

const BreadCrumb: React.FC<{ list: { url: string; label: string }[] }> = ({
  list,
}) => {
  return (
    <ol
      className="flex gap-1"
      // @ts-ignore:next-line
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      {list.map(({ url, label }, index) => (
        <li
          key={url}
          className={`flex gap-1 ${
            index === list.length - 1 && `whitespace-nowrap overflow-hidden`
          }`}
          // @ts-ignore:next-line
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <Link
            className={`font-medium ${
              index === list.length - 1 &&
              `text-ellipsis whitespace-nowrap overflow-hidden`
            }`}
            to={url}
            // @ts-ignore:next-line
            itemprop="item"
          >
            {/* @ts-ignore:next-line */}
            <span itemprop="name">{label}</span>
          </Link>
          {/* @ts-ignore:next-line */}
          <meta itemprop="position" content={`${index + 1}`} />
          {index !== list.length - 1 && <div className="font-thin	">/</div>}
        </li>
      ))}
    </ol>
  );
};

export default BreadCrumb;
